/**
 * GRM-specific configuration for Home Page
 *
 * Extends default configuration with GRM-specific customizations
 */

// Import GRM-specific images
import backgroundImage from 'assets/images/grm/grm_dashboard_header.jpg';
import logoImage from 'assets/images/grm/grm_logo.jpg';

export const grmHomeConfig = {
  welcomeMessage: 'Welcome to GRM Intelligence',
  subtitle: 'Optimize your restaurant operations with real-time insights',
  bodyMessage: 'Access your performance metrics, labor analytics, and operational insights.',
  futurePhaseNote: 'Performance dashboards and AI recommendations coming soon',
  headerBg: backgroundImage,
  logo: logoImage,
};

export default grmHomeConfig;
